import { useEffect } from "react";
import { useNavigate } from "react-router";
import { authService } from "@/services/AuthService";

const LogoutCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const completeLogout = async () => {
      try {
        await authService.completeLogout();
        navigate("/");
      } catch (error) {
        console.error("Logout failed:", error);
        navigate("/");
      }
    };

    completeLogout();
  }, [navigate]);

  return <div>Completing logout...</div>;
};

export default LogoutCallback;
